/**
 * LootPop Component
 *
 * Floating animation that appears when loot/items are gained.
 * Shows item name, quantity, and rarity color with upward float + fade animation.
 *
 * @component
 * @example
 * <LootPop
 *   item={{ name: "Iron Ore", rarity: "common", quantity: 5 }}
 *   position={{ x: 100, y: 200 }}
 *   onComplete={() => console.log('animation done')}
 * />
 */

import { motion } from 'framer-motion';
import { getRarityColor } from '../../utils/rarityUtils';

export function LootPop({ item, position, onComplete }) {
  const rarityColor = getRarityColor(item.rarity || 'common');
  const horizontalDrift = Math.random() * 40 - 20;

  return (
    <motion.div
      initial={{
        opacity: 1,
        y: 0,
        scale: 1,
        x: 0
      }}
      animate={{
        opacity: 0,
        y: -160,
        scale: 1.3,
        x: horizontalDrift
      }}
      transition={{
        duration: 2,
        ease: 'easeOut',
        opacity: { duration: 1.2, delay: 0.6 }
      }}
      onAnimationComplete={onComplete}
      className="absolute pointer-events-none font-bold text-lg z-notification drop-shadow-lg"
      style={{
        left: '10rem',
        bottom: '20px',
        color: rarityColor,
        textShadow: `0 0 8px ${rarityColor}, 0 2px 4px rgba(0, 0, 0, 0.8)`
      }}
    >
      <div className="flex items-center gap-2">
        <span className="text-2xl">+{item.quantity || 1}</span>
        <span className="text-base">{item.name}</span>
      </div>
    </motion.div>
  );
}

export default LootPop;
